import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ExternalLink, Loader2 } from 'lucide-react';
import Pagination from '../components/common/Pagination';

const PAGE_SIZE = 5;

function ChannelSection({ ch, rows }) {
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(rows.length / PAGE_SIZE);
  const paged = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <>
    <div className="bg-white/[0.03] rounded-xl border border-white/[0.06] overflow-hidden">
      <div className="px-4 py-3 bg-white/[0.03] border-b border-white/[0.06] flex items-center gap-2">
        <span className="font-semibold text-white text-sm">{ch}</span>
        <span className="text-xs text-slate-500">{rows.length}건</span>
      </div>
      <table className="w-full text-sm table-fixed">
        <colgroup>
          <col className="w-auto" />
          <col className="hidden sm:table-column w-28" />
          <col className="w-20" />
          <col className="w-16" />
        </colgroup>
        <thead>
          <tr className="text-xs text-slate-400 uppercase border-b border-white/[0.04]">
            <th className="px-4 py-3 text-left">곡명</th>
            <th className="px-4 py-3 text-center hidden sm:table-cell">유형</th>
            <th className="px-4 py-3 text-center">영상</th>
            <th className="px-4 py-3 text-center">게시일</th>
          </tr>
        </thead>
        <tbody>
          {paged.map((r) => (
            <tr key={r.id} className="border-t border-white/[0.04] hover:bg-white/[0.03] transition-colors">
              <td className="px-4 py-2.5 font-medium text-white">
                <div className="truncate max-w-[160px] sm:max-w-none">{r.songName || '-'}</div>
                {r.artist && <span className="text-xs text-slate-500">({r.artist})</span>}
              </td>
              <td className="px-4 py-2.5 text-center hidden sm:table-cell whitespace-nowrap">
                <span className="px-2 py-0.5 rounded-full text-xs bg-sky-500/15 text-sky-300">
                  {r.videoType || '-'}
                </span>
              </td>
              <td className="px-4 py-2.5 text-center whitespace-nowrap">
                {r.linkUrl ? (
                  <a href={r.linkUrl} target="_blank" rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-sky-400 hover:underline text-xs">
                    <ExternalLink size={12} className="shrink-0" />
                    영상 보기
                  </a>
                ) : (
                  <span className="text-slate-500 text-xs">{r.linkText || '-'}</span>
                )}
              </td>
              <td className="px-4 py-2.5 text-slate-400 text-xs text-center whitespace-nowrap">{r.publishDate || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {totalPages > 1 && (
      <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
    )}
    </>
  );
}

export default function MyPromotionReportPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/promotion-report/my')
      .then(({ data }) => setRows(data.rows || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const byChannel = rows.reduce((acc, r) => {
    const key = r.channel || '기타';
    if (!acc[key]) acc[key] = [];
    acc[key].push(r);
    return acc;
  }, {});

  const channels = Object.keys(byChannel).sort();

  return (
    <div>
      <div className="flex mb-8 justify-center items-center">
        <div className="text-xl sm:text-2xl font-bold text-white tracking-tight">홍보리포트</div>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 size={32} className="animate-spin text-slate-400" /></div>
      ) : rows.length === 0 ? (
        <div className="text-center py-20 text-slate-500">
          <p>아직 홍보리포트 데이터가 없습니다</p>
        </div>
      ) : (
        <div className="space-y-4">
          <p className="text-xs text-slate-500">총 {rows.length}건 · {channels.length}개 채널</p>
          {channels.map((ch) => (
            <ChannelSection key={ch} ch={ch} rows={byChannel[ch]} />
          ))}
        </div>
      )}
    </div>
  );
}
